import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function RichTextEditor({ label, labelClass, name, required, leftLabel, value, onChange, ...props }: any) {
    return (
        <div>
            <label className={`input-label text-nowrap ${labelClass} ${required ? 'required' : ''}`}>
                {label}{leftLabel}{name}
                {required && <span className="required-star text-danger ms-1">*</span>}
            </label>
            <ReactQuill
                value={value}
                onChange={onChange}
                {...props}
            />
        </div>
    );
}

export default RichTextEditor;
